import React from 'react';

import type { SymptomLocation } from '../types';

// 数字を丸数字に変換
const toCircledNumber = (num: number): string => {
  const circledNumbers = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'];
  return circledNumbers[num - 1] || `(${num})`;
};

// 情報表示行（SymptomLocationRows 内で使用する軽量版）
const InfoRow: React.FC<{ label: string; value: string | undefined }> = ({
  label,
  value,
}) => (
  <div className="info-row">
    <p className="info-label">{label}</p>
    <div className="info-value-wrap">
      <p className="info-value">{value || 'ー'}</p>
    </div>
  </div>
);

interface SymptomLocationRowsProps {
  symptomLocations: SymptomLocation[] | undefined;
}

/**
 * 依頼場所・依頼症状の表示コンポーネント
 *
 * FEAT-3.2 (pptx仕様): 場所→症状の順で表示する。
 * 複数件の場合は丸数字 (①②…) を付与する。
 */
export const SymptomLocationRows: React.FC<SymptomLocationRowsProps> = ({
  symptomLocations,
}) => {
  if (!symptomLocations || symptomLocations.length === 0) {
    return (
      <>
        <InfoRow label="依頼場所" value={undefined} />
        <InfoRow label="依頼症状" value={undefined} />
      </>
    );
  }

  if (symptomLocations.length === 1) {
    return (
      <>
        <InfoRow label="依頼場所" value={symptomLocations[0].location} />
        <InfoRow label="依頼症状" value={symptomLocations[0].symptom} />
      </>
    );
  }

  return (
    <>
      {symptomLocations.map((item, index) => (
        <React.Fragment key={index}>
          <InfoRow
            label={`依頼場所${toCircledNumber(index + 1)}`}
            value={item.location}
          />
          <InfoRow
            label={`依頼症状${toCircledNumber(index + 1)}`}
            value={item.symptom}
          />
        </React.Fragment>
      ))}
    </>
  );
};
